import { NitroModules } from "react-native-nitro-modules";
import { assertAndroidHaptic, assertImpact, assertNotification } from "./validation";
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OneHaptics");
  return hybrid;
}
var Haptics = Object.freeze({
  selection() {
    native().selection();
  },
  impact(style) {
    assertImpact(style);
    native().impact(style);
  },
  notification(type) {
    assertNotification(type);
    native().notification(type);
  },
  performAndroidHaptics(type) {
    assertAndroidHaptic(type);
    native().performAndroidHaptics(type);
  }
});
export {
  Haptics
};
//# sourceMappingURL=index.native.js.map
